import React from 'react';

export const XIcon = props => (
  <svg viewBox="0 0 40 40" aria-hidden="true" {...props}>
    <path d="M 10,10 L 30,30 M 30,10 L 10,30" />
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/Icons/XIcon.js